module.exports = __webpack_public_path__ + "static/media/SupplyChain5.1ccb3516.png";